import script from "./DistributorMap.vue?vue&type=script&setup=true&lang=ts"
export * from "./DistributorMap.vue?vue&type=script&setup=true&lang=ts"

import "./DistributorMap.vue?vue&type=style&index=0&id=25813b32&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25813b32"]])

export default __exports__